import { ViewAvenantPage } from "@features/rh/contrats/components/avenants/ViewAvenantPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";

export const Route = createFileRoute("/_app/rh/contrats/$id/avenants/$avenantId/view")({
  loader: requirePermission(PERMISSIONS.RH.AVENANTS.VIEW),
  staticData: {
    title: "Voir un avenant",
    icon: FileText,
    permission: PERMISSIONS.RH.AVENANTS.VIEW,
    section: "App",
    showInBreadcrumb: true,
  },
  component: ViewAvenantPage,
});
